type FetchOptions = {
  method?: 'GET' | 'POST' | 'DELETE';
  body?: unknown;
};

export class ApiError extends Error {
  constructor(public status: number, public code: string, message?: string) {
    super(message ?? code);
  }
}

export async function api<T>(path: string, opts: FetchOptions = {}): Promise<T> {
  const method = opts.method ?? 'GET';
  const headers: Record<string, string> = {
    Accept: 'application/json',
  };
  if (method !== 'GET') {
    headers['X-Requested-With'] = 'portal';
    headers['Content-Type'] = 'application/json';
  }
  const res = await fetch(path, {
    method,
    credentials: 'include',
    headers,
    body: opts.body !== undefined ? JSON.stringify(opts.body) : undefined,
  });
  const text = await res.text();
  const data = text ? safeJson(text) : null;
  if (!res.ok) {
    const code = (data && typeof data === 'object' && 'error' in data ? (data as { error?: string }).error : undefined) ?? `http_${res.status}`;
    throw new ApiError(res.status, code);
  }
  return data as T;
}

function safeJson(text: string): unknown {
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}
